import {useEffect, useState} from "react";

export function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState(null);

  useEffect(() => {
    let lastScrollY = window.scrollY;

    const updateScrollDirection = () => {
      const direction = window.scrollY > lastScrollY ? "down" : "up";
      if (direction !== scrollDirection && (window.scrollY - lastScrollY > 10 || window.scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);
      }
      lastScrollY = window.scrollY > 0 ? window.scrollY : 0;
    };
    window.addEventListener("scroll", updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener("scroll", updateScrollDirection); // clean up
    }
  }, [scrollDirection]);

  return scrollDirection;
}